<template>
  <footer>
    <p>Horarios de atencion: Lunes a Sabado 9:00am a 9:00pm, Domingos cerramos y comemos pastel</p>
    <p>Pasteles LaunchX. Midtown, Calle Colon 611. Guadalajara, Jalisco, México. Telefono: 3333333333</p>
    <p><span>Felices de servirte. Todos los derechos reservados. Proyecto hecho para LaunchX por Fernando de Lafuente</span></p>
  </footer>
</template>    

<script>

export default {
  name: 'Footer',
}
</script>

<style>
footer p {
    text-align: right; 
    font-size: 20px;
    color: black;
    font-weight: bold;
}
footer p span {
  font-size: 25px;
  text-decoration: underline;
}
</style>
